import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_HOMEPAGE_PETITION_MARQUEE = defineFcm('homepage_petition_marquee')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				petitions: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							petitionId: { type: 'number' },
							summarizedTitle: { type: 'string' },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		petitions: [],
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-middle-end',
		supportedGroups: { countries: true },
		context: 'Homepage petition marquee',
		description:
			'Curated petitions shown in the homepage marquee. Each entry pairs a petition ID with a short summarized title used in place of the petition ask; the petition image and signature count are pulled from the petition itself.',
		import: false,
		template: {
			isEnabled: true,
			petitions: [
				{
					petitionId: 123456,
					summarizedTitle: 'Protect the national parks',
				},
			],
		},
	});
